export const content = "BetterHelp offers virtual sessions for:\u00a0\n\n*   Psychotherapy (also known as talk therapy)\n*   Psychiatric consultations\n*   Medication management\n";
